import { render, staticRenderFns } from "./conferencePaper.vue?vue&type=template&id=eacd15fe&scoped=true"
import script from "./conferencePaper.vue?vue&type=script&lang=js"
export * from "./conferencePaper.vue?vue&type=script&lang=js"
import style0 from "./conferencePaper.vue?vue&type=style&index=0&id=eacd15fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacd15fe",
  null
  
)

export default component.exports